import { api } from '../../base';
import {
    ICreateRejectReasonAction,
    ICreateTagAction,
    IDeleteCompanyMailboxAction,
    IPostConnectGmailAction,
    IPostConnectOutlookAction,
    IUpdateRejectReasonAction,
    IUpdateTagAction,
} from '../organization/redux';

const REJECT_REASONS_URL = 'organizations/reject-reasons/';

export const fetchCompanyInfo = (companyKey: string) => {
    return api.get({
        url: 'organizations/organizationspublic/get_base_company_info/',
        queryParams: { ck: companyKey },
    });
};

export const postConnectGmail = (payload: IPostConnectGmailAction) => {
    return api.post({
        url: 'connectcompanygmailcallback/',
        data: payload,
    });
};

export const postConnectOutlook = (payload: IPostConnectOutlookAction) => {
    return api.post({
        url: 'connectcompanyoutlookcallback/',
        data: payload,
    });
};

export const deleteCompanyMailbox = (payload: IDeleteCompanyMailboxAction) => {
    return api.delete({
        url: `organizations/company-mailboxes/${payload.id}/`,
    });
};

export const fetchTags = () => {
    return api.get({
        url: 'tags/',
    });
};

export const createTag = (payload: ICreateTagAction) => {
    return api.post({
        url: 'tags/',
        data: payload,
    });
};

export const updateTag = (payload: IUpdateTagAction) => {
    return api.put({
        url: `tags/${payload.tag_id}/`,
        data: payload,
    });
};

export const deleteTag = (tagId: number) => {
    return api.delete({
        url: `tags/${tagId}/`,
    });
};

export const fetchRejectReasons = () => {
    return api.get({
        url: REJECT_REASONS_URL,
    });
};

export const createRejectReason = (payload: ICreateRejectReasonAction) => {
    return api.post({
        url: REJECT_REASONS_URL,
        data: { reason: payload.reason },
    });
};

export const updateRejectReason = (payload: IUpdateRejectReasonAction) => {
    return api.patch({
        url: `${REJECT_REASONS_URL}${payload.id}/`,
        data: { reason: payload.reason },
    });
};

export const deleteRejectReason = (id: number) => {
    return api.delete({
        url: `${REJECT_REASONS_URL}${id}/`,
    });
};

export const fetchCompanySettings = () => {
    return api.get({
        url: 'organizations/settings/',
    });
};

export const updateCompanySettings = (payload: FormData | object) => {
    const isFormData = payload instanceof FormData;

    return api.patch({
        url: 'organizations/settings/',
        data: payload,
        ...(isFormData && {
            config: {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            },
        }),
    });
};
